import type { FunctionComponent } from 'react';
import { Trans } from 'react-i18next';
import Dialog, { Clip } from '../molecules/Dialog';
import DialogHeader, { Highlight } from '../molecules/DialogHeader';
import RoundButton from '../atoms/RoundButton.Container';
import Highscore from '../atoms/Highscore';
import type { Points, TotalScore } from '../../data/Score';
import type { HighscoreEntry } from '../../data/Highscore';

export interface Props {
	playerName: string;
	score: TotalScore;
	points: Points;
	highscoreEntries: HighscoreEntry[];
	onClose: () => void;
}

const HighscoreDialog: FunctionComponent<Props> = (props: Props) => {
	const { playerName, score, points, highscoreEntries, onClose } = props;

	return (
		<Dialog
			closeButton={
				<RoundButton
					onClick={onClose}
					width="32vmin"
					height="20vmin"
					position="absolute"
					right="1vw"
					top="0vh"
				>
					<Trans>highscore.close</Trans>
				</RoundButton>
			}
		>
			<Clip>
				<Highscore
					entries={highscoreEntries}
					highlight={{ playerName, score, synced: false }}
					position="absolute"
					left="48%"
					right="0"
					top="30%"
					bottom="13%"
				/>
			</Clip>
			<DialogHeader>
				<Highlight>
					<Trans tOptions={{ returnObjects: true }} count={points}>
						highscore.points
					</Trans>
				</Highlight>
				<br />
				<Trans>highscore.congratulation</Trans>
			</DialogHeader>
		</Dialog>
	);
};

export default HighscoreDialog;
